import Grid from "@mui/material/Grid";
import { useTheme } from "@mui/material/styles";

import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import ProfileInfoCard from "examples/Cards/InfoCards/ProfileInfoCard";
import ProfilesList from "examples/Lists/ProfilesList";

import Header from "layouts/profile/components/Header";
import profilesListData from "layouts/profile/data/profilesListData";

function Profile() {
  const theme = useTheme();

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox
        py={3}
        px={2}
        sx={{
          backgroundColor: theme.palette.mode === "dark" ? "#121212" : "#f9f9f9",
          borderRadius: "16px",
          mx: 1,
          boxShadow:
            theme.palette.mode === "dark"
              ? "0 0 12px rgba(0,0,0,0.4)"
              : "0px 4px 24px rgba(0,0,0,0.05)",
        }}
      >
        <Header />
        <MDBox mt={5} mb={3}>
          <Grid container spacing={1}>
            <Grid item xs={12} md={6} xl={4}>
              <ProfileInfoCard
                title="profile information"
                description="Hi, I’m Alec Thompson, Decisions: If you can’t decide, the answer is no. If two equally difficult paths, choose the one more painful in the short term."
                info={{
                  fullName: "Alec M. Thompson",
                  mobile: "(44) 123 1234 123",
                  email: "alec@domain.com",
                  location: "USA",
                }}
                social={[
                  {
                    link: "https://facebook.com",
                    icon: <i className="fab fa-facebook" />,
                    color: "facebook",
                  },
                  {
                    link: "https://twitter.com",
                    icon: <i className="fab fa-twitter" />,
                    color: "twitter",
                  },
                  {
                    link: "https://instagram.com",
                    icon: <i className="fab fa-instagram" />,
                    color: "instagram",
                  },
                ]}
                action={{
                  route: "",
                  tooltip: "Edit Profile",
                }}
                shadow={false}
              />
            </Grid>
            <Grid item xs={12} xl={4}>
              <ProfilesList title="conversations" profiles={profilesListData} shadow={false} />
            </Grid>
          </Grid>
        </MDBox>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Profile;
